module.exports = __webpack_public_path__ + "static/media/walkMonster.a4117371.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Walk/walkMonster.svg
// module id = 914
// module chunks = 0